import React from 'react';
import './BackToStoreButton.css';
import { useTheme } from '../../context/PortalThemeContext';
import { PiArrowLeft } from 'react-icons/pi';


const BackToStoreButton = ({ addShadow = true }) => {
    const theme = useTheme();
    const shadowStyle = addShadow
        ? { textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)' }
        : {};

    return (
        <a
            href={`https://${theme.store}`}
            target="_blank"
            rel="noopener noreferrer"
            className="back-to-store-button"
            style={{
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
                fontWeight: 600,
                fontSize: '1.125rem',
                mixBlendMode: 'difference',
                ...shadowStyle
            }}
        >
           <PiArrowLeft className="me-1" size={18} />Back to Store
        </a>
    );
};

export default BackToStoreButton;
